const colors = {
  primary: '#525252', // Color for buttons or links
  bg: '#fff', // Background color
  grey: {
    dark: 'rgba(0, 0, 0, .8)',
    default: 'rgba(0, 0, 0, 0.7)',
    light: 'rgba(0, 0, 0, 0.8)',
    ultraLight: 'rgba(0, 0, 0, 6)',
  },
};

const transitions = {
  normal: '0.5s',
};

const fontSize = {
  small: '0.9rem',
};

const theme = {
  colors,
  transitions,
  fontSize,
};

export default theme;
